import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';
import { Button, ButtonStyledButton } from '@codex-brightworld/basics';
import { getCookie, setCookie } from '@codex-brightworld/helpers';

const Wrapper = styled.div`
  background: rgba(245, 247, 253, 0.9);
  border: 1px solid ${({ theme }) => theme.colors.link.default};
  border-radius: 4px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  z-index: 99999999;
  padding: 15px;
  bottom: 25px;
  left: 50%;
  transform: translateX(-50%);
  box-sizing: border-box;
  transition-property: all;
  transition-duration: 0.5s;
  transition-timing-function: cubic-bezier(0.5, 1, 0.5, 1);
  position: fixed;
  width: calc(100% - 30px);
  animation-name: appear;
  animation-duration: 0.5s;
  font-size: 15px;

  @media ${({ theme }) => theme.breakpoints.touch} {
    font-size: 12.6px;
  }

  ${props => props.closed && css`
    bottom: -200px;
  `}

  ${props => props.hidden && css`
    display: none;
  `}

  @keyframes appear {
    0% {
      bottom: -200px;
    }
    100% {
      bottom: 25px;
    }
  }

  ${ButtonStyledButton} {
    margin-left: 20px;
    width: 150px;
    font-size: 1em;
  }

  @media ${({ theme }) => theme.breakpoints.touch} {
    flex-direction: column;
    ${ButtonStyledButton} {
      margin: 10px 0 0;
      font-size: 0.9em;
    }
  }
`;

class CookiesBar extends PureComponent {
  constructor(props) {
    super(props);
    const accepted = getCookie('complianceCookie') === 'on';
    this.state = {
      open: !accepted,
      hidden: accepted
    };
    this.accept = this.accept.bind(this);
  }

  accept() {
    this.hideBar();
    setCookie('complianceCookie', 'on', 14);
  }

  hideBar() {
    this.setState({ open: false });
    setTimeout(() => {
      this.setState({ hidden: true });
    }, 500);
  }

  render() {
    return (
      <Wrapper
        data-qa={this.props.qa}
        closed={!this.state.open}
        hidden={this.state.hidden}
      >
        {this.props.children}
        <Button full onClick={this.accept}>
          {this.props.buttonText}
        </Button>
      </Wrapper>
    );
  }
}

CookiesBar.propTypes = {
  qa: PropTypes.string,
  children: PropTypes.node.isRequired,
  buttonText: PropTypes.string
};

CookiesBar.defaultProps = {
  qa: undefined,
  buttonText: 'Accept & Close'
};

export default CookiesBar;
